import { Header } from "@/components/public/header";
import { Footer } from "@/components/public/footer";
import { CTASection } from "@/components/public/cta-section";
import { FadeIn, StaggerContainer, ScaleIn } from "@/components/ui/scroll-animations";
import { Linkedin } from "lucide-react";

const leadership = [
  {
    name: "Rajesh Sharma",
    role: "Founder & CEO",
    bio: "20+ years in investment banking with experience across M&A, capital markets, and strategic advisory. Former Managing Director at a leading global investment bank. IIM Ahmedabad and IIT Delhi alumnus. Has advised on transactions exceeding $5 billion in aggregate value.",
    image: null,
    linkedin: "https://linkedin.com",
  },
  {
    name: "Priya Mehta",
    role: "Chief Investment Officer",
    bio: "15+ years experience in private equity and credit markets. Led investments across 50+ companies in manufacturing, infrastructure, and technology sectors. CFA Charterholder with an MBA from ISB Hyderabad.",
    image: null,
    linkedin: "https://linkedin.com",
  },
  {
    name: "Amit Kapoor",
    role: "Head of Wealth Management",
    bio: "18+ years managing portfolios for HNIs and family offices. Deep expertise in alternative investments, estate planning, and cross-border structuring. CFP certified with an MBA from IIM Calcutta.",
    image: null,
    linkedin: "https://linkedin.com",
  },
  {
    name: "Sneha Reddy",
    role: "Head of Risk & Compliance",
    bio: "12+ years in risk management and regulatory compliance across asset management and banking. Former regulatory advisor at a Big 4 firm. Company Secretary and LLB from National Law School.",
    image: null,
    linkedin: "https://linkedin.com",
  },
];

const team = [
  { name: "Vikram Singh", role: "Director - Private Credit", linkedin: "https://linkedin.com" },
  { name: "Ananya Gupta", role: "Vice President - Investments", linkedin: "https://linkedin.com" },
  { name: "Rohit Jain", role: "Director - Investor Relations", linkedin: "https://linkedin.com" },
  { name: "Meera Krishnan", role: "Associate Director - Operations", linkedin: "https://linkedin.com" },
];

export default function TeamPage() {
  return (
    <div className="min-h-screen flex flex-col bg-black overflow-x-hidden selection:bg-gold selection:text-black">
      <Header />
      <main className="flex-1 pt-32 pb-40">
        <section className="relative">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-32">
            <div className="text-center max-w-4xl mx-auto mb-32">
              <FadeIn direction="down" delay={0.1}>
                <p className="text-[10px] font-bold text-gold mb-8 uppercase tracking-[0.4em]">Our Team</p>
              </FadeIn>
              <FadeIn direction="up" delay={0.2}>
                <h1 className="text-6xl sm:text-7xl lg:text-8xl font-medium text-white mb-10 leading-[0.9] tracking-tighter">
                  Meet the <br/> <span className="text-zinc-500 italic font-light">Leadership.</span>
                </h1>
              </FadeIn>
              <FadeIn direction="up" delay={0.3}>
                <p className="text-base text-zinc-500 font-light leading-relaxed tracking-wide max-w-2xl mx-auto">
                  A seasoned team of investment professionals architecting outcomes with 
                  precision and clarity. Decades of combined institutional experience.
                </p>
              </FadeIn>
            </div>

            <StaggerContainer stagger={0.12} className="grid lg:grid-cols-2 gap-0 border-l border-t border-zinc-900">
              {leadership.map((member, index) => (
                <FadeIn key={index} direction={index % 2 === 0 ? "left" : "right"}>
                  <div className="p-12 border-r border-b border-zinc-900 hover:bg-zinc-950/40 transition-all duration-700">
                    <div className="flex flex-col sm:flex-row items-start gap-10">
                      <ScaleIn delay={0.1}>
                        <div className="w-24 h-24 bg-zinc-900 border border-zinc-800 flex items-center justify-center flex-shrink-0 transition-transform duration-500 hover:scale-105 rounded-none">
                          <span className="text-xl font-bold text-gold opacity-50">
                            {member.name.split(" ").map(n => n[0]).join("")}
                          </span>
                        </div>
                      </ScaleIn>
                      <div className="flex-1">
                        <div className="flex items-start justify-between gap-4 mb-6 flex-wrap">
                          <div>
                            <h3 className="text-2xl font-medium text-white mb-2 tracking-tight">{member.name}</h3>
                            <p className="text-[10px] font-bold text-gold uppercase tracking-[0.3em]">{member.role}</p>
                          </div>
                          <a
                            href={member.linkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-zinc-700 hover:text-gold transition-colors"
                            data-testid={`link-linkedin-${member.name.toLowerCase().replace(/\s+/g, "-")}`}
                          >
                            <Linkedin className="w-4 h-4" />
                          </a>
                        </div>
                        <p className="text-sm text-zinc-500 font-light leading-relaxed">
                          {member.bio}
                        </p>
                      </div>
                    </div>
                  </div>
                </FadeIn>
              ))}
            </StaggerContainer>

            <div className="mt-40 border-t border-zinc-900 pt-20">
              <h2 className="text-center text-[10px] font-bold text-zinc-600 uppercase tracking-[0.4em] mb-16">Engagement & Ops</h2>
              <StaggerContainer stagger={0.08} className="grid grid-cols-2 md:grid-cols-4 gap-0 border-l border-t border-zinc-900">
                {team.map((member, index) => (
                  <FadeIn key={index} direction="up" delay={index * 0.1}>
                    <div className="p-10 border-r border-b border-zinc-900 hover:bg-zinc-950/40 transition-colors">
                      <h4 className="text-white font-medium mb-1 tracking-tight">{member.name}</h4>
                      <p className="text-[9px] text-zinc-600 uppercase tracking-widest">{member.role}</p>
                    </div>
                  </FadeIn>
                ))}
              </StaggerContainer>
            </div>
          </div>
        </section>

        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
